import React, { useContext } from "react";
import styled from "styled-components";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import request from "../../utils/http";
import { useState } from "react";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import { ProgressBar } from "baseui/progress-bar";
import enums from "../../utils/enums";
import { Tag } from "baseui/tag";
import { AppContextValue } from "../../AppContext";

const Container = styled.div``;

const StyledTableRow = styled.div`
	display: contents;
	cursor: pointer;
`;

const CandidateHome = (props: any) => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();
	const [candidates, setCandidates] = useState([] as any);
	const [filter, setFilter] = useState("");
	const [pilAccess, setPilAccess] = useState(Boolean);

	const loadCandidates = async () => {
		let result = await request(
			"GET",
			`/api/admin/candidate/gc${
				props.mode === "my-candidates" ? "/my" : 
				props.mode === "all-candidates" ? "/all" : filter
			}`,
			null
		);
		if (result.success && result.data) {
			setCandidates(result.data.candidates);
		}
	};

	const loadPILAccess = async () => {
		let result = await request(
			"GET",
			`/api/admin/utility/pil-permission-get`,
			null
		);
		if (result.success && result.data) {
			setPilAccess(result.data.pilAccess);
		}
	};

	useEffect(() => {	
		loadCandidates();
	}, [urlParams]);

	useEffect(() => {	
		loadPILAccess();
	}, [urlParams]);

	return (
		<Container>
			<ActionHeader>
				{props.mode === "my-candidates" ? (
					<h1>My Candidates</h1>
				) : (
					<h1>Candidates</h1>
				)}

				<Button
					onClick={() => {
						navigate({
							pathname: `/candidate/create`,
						});
					}}
				>
					PPCS Create
				</Button>
				&nbsp; &nbsp;
				{pilAccess && (
					<Button
						onClick={() => {
							navigate({
								pathname: `/candidate/create-pil`,
							})
						}}
					>
						PIL Create
					</Button>				
				)
				}

			</ActionHeader>
			<hr />
			<StyledTable
				role="grid"
				$gridTemplateColumns={
					props.mode !== "my-candidates"
						? "1fr 1fr 1fr 1fr 1fr 1fr 1fr"
						: "1fr 1fr 1fr 1fr 1fr 1fr"
				}
			>
				<StyledTableRow role="row">
					<StyledHeadCell>Name</StyledHeadCell>
					<StyledHeadCell>Group</StyledHeadCell>
					{props.mode !== "my-candidates" && (
						<StyledHeadCell>Allocated to</StyledHeadCell>
					)}
					<StyledHeadCell>MOJ Status</StyledHeadCell>
					<StyledHeadCell>Onboarding Progress</StyledHeadCell>
					<StyledHeadCell>Current Task</StyledHeadCell>
					<StyledHeadCell>Task Progress</StyledHeadCell>
				</StyledTableRow>

				{candidates &&
					candidates.map((candidate: any, i: number) => {
						const striped = i % 2 === 0;
						const mojStatus = enums.candidateMojStatus.find(
							(item: any) => item.value === candidate.currentMOJStatus
						) as any;
						const candidateProgressStatus = enums.candidateProgress.find(
							(item: any) => item.value === candidate.candidateProgress
						) as any;

						return (
							<StyledTableRow
								role="row"
								onClick={() => {
									navigate({
										pathname: `/candidate/${candidate.id}`,
									});
								}}
							>
								<StyledBodyCell $striped={striped}>
									{candidate.name}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{candidate.candidateType}
								</StyledBodyCell>
								{props.mode !== "my-candidates" && (
									<StyledBodyCell $striped={striped}>
										{candidate.allocatedTo}
									</StyledBodyCell>
								)}
								<StyledBodyCell $striped={striped}>
									<Tag
										closeable={false}
										kind={mojStatus?.kind ?? "primary"}
										variant={mojStatus?.variant ?? "outlined"}
										overrides={{ Text: { style: { maxWidth: "" } } }}
									>
										{mojStatus?.labelShort ?? mojStatus?.label ?? "Unknown"}
									</Tag>
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{candidateProgressStatus.label}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{candidate.currentTask}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									<ProgressBar
										value={
											(candidate.currentTaskStep / candidate.currentTaskSteps) *
											100
										}
									/>
								</StyledBodyCell>
							</StyledTableRow>
						);
					})}
			</StyledTable>
		</Container>
	);
};
export default CandidateHome;
